import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsLayout } from "src/pages/CoachProductsLayout";
import { invoicingIntegrationQueryOptions } from "src/queries/invoicingIntegration";

export const Route = createFileRoute("/_auth/_coach/products/_tabs")({
  component: CoachProductsLayout,
  ssr: true,
  async loader({ context }) {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...invoicingIntegrationQueryOptions(),
        staleTime: "static",
      });

      return { data: null };
    });
  },
});
